var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.6665C19.6274 25.6665 25 20.2939 25 13.6665C25 7.03909 19.6274 1.6665 13 1.6665C6.37258 1.6665 1 7.03909 1 13.6665C1 20.2939 6.37258 25.6665 13 25.6665Z",
    fill: "#F2E93E",
    stroke: "#4F4E4E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.67 7.29639H9.89996C9.37996 7.29639 8.95996 7.71639 8.95996 8.23639V19.5564C8.95996 20.0764 9.37996 20.4964 9.89996 20.4964C10.42 20.4964 10.84 20.0764 10.84 19.5564V16.7264H13.67C16.27 16.7264 18.39 14.6064 18.39 12.0364C18.39 9.46639 16.27 7.29639 13.67 7.29639ZM13.67 14.8364H10.84V9.17639H13.67C15.23 9.17639 16.5 10.4464 16.5 12.0064C16.5 13.5664 15.23 14.8364 13.67 14.8364Z",
    fill: "#4F4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.58c4a3dc16a99edfc9943870e4d9113a.svg";
export { ForwardRef as ReactComponent };